import React, { useContext, useState } from 'react'

import { PanelDeControlContext } from '../../../context/PanelDeControlContext';
import useForm from '../../../hooks/useForm';
import apiEventos from '../../../services/apis/apiEventos';
import { types } from '../../../types/types';

import AddIcon from '../../ui/AddIcon';
import EventoCard from './EventoCard';

import style from '../../../assets/styles/panelDeControl.module.css'

const PanelEventos = () => {

    const { eventos, dispatchEventos, setEventoSeleccionado } = useContext( PanelDeControlContext );

    const [ menuDesplegado, setMenuDesplegado ] = useState( false );
    const { values, handleInputChange, reset } = useForm({ nombreEvento: '' })
    const { nombreEvento }= values;

    const desplegarMenuAgregar = () => {
        setMenuDesplegado( !menuDesplegado );
    }

    const agregarEvento = async() => {

        const response = await apiEventos.post({ nombre: nombreEvento })
        if( response.error ) { return console.log(response.error.errorMsg )}

        dispatchEventos({ type: types.eventoAgregado, payload: response.response.data.evento });
        reset();
        desplegarMenuAgregar()

    }

    return (eventos && 
    
    <div className={ style.panelEventos }>

        <div className='row align-items-center'>
            <h2>Eventos</h2>
            <AddIcon addCallback={ desplegarMenuAgregar } />
        </div>



    { menuDesplegado && 

    <div>

        <h3>Agregar Evento</h3>

        <form >
            <label className='form-label' htmlFor='nombreEvento'>Nombre del Evento</label>
            <input value={ nombreEvento } onChange= { handleInputChange } 
                className='form-control' type="text" name="nombreEvento" />
        </form>

        <div className="row justify-content-end gx-1 mt-3">
            <div className="col-auto">
                <button onClick={ () => desplegarMenuAgregar() } className="btn btn-secondary">
                    Cancelar
                </button>
            </div>
            <div className="col-auto">
                <button 
                    onClick={ agregarEvento }
                    className="btn btn-primary">
                    Agregar
                </button>
            </div>
        </div>

    </div>


    }

    <div className={ style.cardGroup }>
        {
            eventos.map( evento => (
                <EventoCard
                    onClick={ setEventoSeleccionado } 
                    key={ evento._id }
                    { ...evento } />
            ))
        }
    </div>

    </div>)
}

export default PanelEventos
